// extracted by mini-css-extract-plugin
export default {"cls1":"LoadingSheet-Sheet-module--cls1--jJmAa","cls2":"LoadingSheet-Sheet-module--cls2--zMxvB LoadingSheet-Sheet-module--cls1--jJmAa"};